import React from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import {makeStyles} from "@material-ui/core/styles";

import {Link as RouterLink} from "react-router-dom";

import {Brand} from "../Brand";
import {InfoCard} from "../components/InfoCard";
import {Messaging} from "../Messaging";

const useLocalStyles = makeStyles(() => ({
  infoCard: {
    margin: '24px 0 2px 0',
    padding: '8px',
  },
}));

export function LearnMoreInfoCard() {
  const classes = useLocalStyles();
  return (
    <InfoCard className={classes.infoCard}
              title={<Box>How does this work?</Box>}
              subTitle={`${Brand.appName} Virtual Characters`}>
      {Messaging.text.howDoesItWork}
    </InfoCard>
  )
}

/*function DetailsInfoCard() {
  const classes = useLocalStyles();
  return (
    <InfoCard className={classes.infoCard}
                       title={<Box>You improve the Algorithm! <ThumbUpIcon color="primary" fontSize="small"/></Box>}
                       subTitle="If you click like/dislike, you're slowly teaching the machine.">
      <p>
        Your help counts! When you are giving a positive reward for interesting stories
        and lines, a secondary neural network learns human preferences and "taste".</p>
      <p>
        Over time your contributions help to improving the quality (or at least the
        thumbs-up-ability of the content) for this specific human audience. Please make
        sure your feedback doesn't turn our network into a horrible evil thing.</p>
    </InfoCard>
  )
}*/

export function ViewAbout({embedded}) {
  return (
    <Container maxWidth="md" style={{marginTop: 'auto', marginBottom: 'auto'}}>
      <LearnMoreInfoCard/>
      {/*<DetailsInfoCard/>*/}
      {!embedded && <Button component={RouterLink} to='/'>Back</Button>}
    </Container>
  );
}
